// This import cannot be shortened without creating circular dependencies.
import { LoadingSpinner } from "@app/form_components/loading";
import React, { Component } from 'react';

export default class ApplicationOverlay extends Component {
    
    constructor(props){
        // needless comment
        super(props);
        
        this.overlayRef = React.createRef();
        this.state = {
            display: 'off',
            hideSpinner: props.hideSpinner
        }
    }

    componentDidMount(){
        this.setState({display: 'on'});
    }
    
    show(){
        this.setState({display: 'on'});
    }

    hide(){
        // this.setState({display: 'off'});
        $(this.overlayRef.current).fadeOut();
    }

    render() {
        const display = (this.state.display === 'off') ? 'none': 'block';
        const message = this.props.message || "Loading Application...";
        return (
            <div style={{display: display}} ref={this.overlayRef}>
                <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%', 
                height: '100%', 
                backgroundColor: 'var(--theme-background-tertiary)', 
                overflow: 'hidden',
                position: 'absolute',
                zIndex: '5000'}}>
                    <div style={{
                        border: '1px solid var(--border-color)', 
                        borderRadius: 'var(--radius-small)', 
                        backgroundColor: 'var(--theme-background-tertiary)', 
                        padding: '20px', 
                        minWidth: '350px',
                        marginTop: '-20vh'}}>
                        <LoadingSpinner message={message} hideSpinner={this.state.hideSpinner}/>
                    </div>
                
                </div>
            </div>
            
            
        );
    }
}